<template>
  <div>
    <!-- 学生请假列表搜索 运营端portOrg===0、学校端 portOrg===2、机构端 portOrg===3 -->
    <div v-if="leaveListSearch" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem
            v-if="portOrg === 0"
            class="sch-form-item"
            prop="areaCode"
            label=""
          >
            <RemoteSelect
              v-model="formValidate.areaCode"
              placeholder="请选择地区"
              :remote-method="getAreaCodeList"
              :loading="loadingArea"
              :clearable="false"
              @change="handleAreaSelect"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="item in areacodeList"
                :key="item.areaCode"
                :label="item.areaName"
                :value="item.areaCode"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>
          <FormItem
            v-if="portOrg === 3"
            class="sch-form-item"
            prop="areaCode"
            label=""
          >
            <Select
              v-model="formValidate.areaCode"
              class="search-select-430"
              @on-change="handleSelectArea"
            >
              <Option
                v-for="(item, index) in listArea"
                :key="index"
                :value="item.areaCode"
              >{{ item.areaName }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="leaveId" label="">
            <Input
              v-model="formValidate.leaveId"
              clearable
              placeholder="请输入请假编号ID"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem
            v-if="portOrg === 0"
            class="sch-form-item"
            prop="schoolIdShow"
            label=""
          >
            <RemoteSelect
              v-model="formValidate.schoolIdShow"
              :placeholder="
                formValidate.areaCode ? '请选择学校' : '请先选择地区'
              "
              :remote-method="getSchoolListForAreacode"
              :loading="loadingSchool"
              :disabled="!formValidate.areaCode"
              @clear="getSchoolListForAreacode('')"
              @change="handleSchoolSelect"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="item in schoolList"
                :key="item.orgId"
                :label="item.name"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>
          <FormItem
            v-else-if="portOrg === 2"
            class="sch-form-item"
            prop="schoolIdShow"
            label=""
          >
            {{ userInfo.orgName }}
          </FormItem>
          <FormItem v-else class="sch-form-item" prop="schoolIdShow" label="">
            <RemoteSelect
              v-model="formValidate.schoolIdShow"
              placeholder="请选择学校"
              :remote-method="getSchoolList"
              :loading="loadingSchool"
              @clear="getSchoolList('')"
              @change="handleSchoolSelect"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="item in schoolList"
                :key="item.orgId"
                :label="item.name"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>
          <FormItem label="">
            <FormItem label="">
              <CascaderYearTerms
                ref="cascaderYearTerms"
                :placeholder="`请选择年度学期`"
                :clearable="false"
                :cache-year-terms="initYear"
                @on-change="onCascaderChange"
              ></CascaderYearTerms>
            </FormItem>
          </FormItem>
          <FormItem prop="orgId" label="">
            <span v-if="portOrg == 3">{{ userInfo.orgName }}</span>
            <choose-apply
              v-else
              ref="chooseApplyRef"
              org-type=""
              :year-term-code="yearTermCode"
              @on-change="handleOnApplyChange"
            ></choose-apply>
          </FormItem>
          <FormItem prop="classroomName" label="">
            <Input
              v-model="formValidate.classroomName"
              clearable
              placeholder="课程班级名称"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="studentName" label="">
            <Input
              v-model="formValidate.studentName"
              clearable
              placeholder="请输入学生姓名"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="leaveStautsShow" label="">
            <Select
              v-model="formValidate.leaveStautsShow"
              placeholder="请选择请假状态"
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in leaveStatusList"
                :key="index"
                :value="item.status"
              >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="refundStatusShow" label="">
            <Select
              v-model="formValidate.refundStatusShow"
              placeholder="请选择是否可退款"
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in refundStatusList"
                :key="index"
                :value="item.status"
              >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="refundStsShow" label="">
            <Select
              v-model="formValidate.refundStsShow"
              placeholder="请选择退款状态"
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in refundStsList"
                :key="index"
                :value="item.status"
              >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="">
            <div class="date-line">
              <DatePicker
                v-model="dateValue"
                type="datetimerange"
                placeholder="选择开始请假时间 至 结束请假时间"
                style="width: 320px"
                transfer
                @on-change="onChangeDate"
              ></DatePicker>
            </div>
          </FormItem>
          <Button
            class="search-430"
            type="primary"
            @click="handleSearch"
          >查询</Button>
          <Button class="search-430" @click="handleFormData">重置</Button>
        </Row>
      </Form>
    </div>
    <!-- 导入请假单的搜索 运营端portOrg===0、学校端 portOrg===2 -->
    <div v-if="leadInSearch" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        :label-width="0"
        label-position="left"
        :rules="leadInRule"
        class="search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <Col v-if="portOrg === 0" class-name="input-select-430">
            <FormItem label="" class="sch-form-item" prop="schoolId">
              <RemoteSelect
                v-model="formValidate.schoolIdShow"
                placeholder="请选择学校"
                :remote-method="getSchoolList"
                :loading="loadingSchool"
                @clear="getSchoolList('')"
                @change="handleSchoolSelect"
                @visible-change="loadAllList"
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.orgId"
                  :label="item.name"
                  :value="item.orgId"
                >
                </el-option>
              </RemoteSelect>
            </FormItem>
          </Col>
          <Col v-if="portOrg === 2" class-name="input-select-430">
            <FormItem class="sch-form-item" prop="schoolIdShow">
              {{ userInfo.orgName }}
            </FormItem>
          </Col>
          <Col class-name="input-select-430">
            <FormItem label="" prop="branchId">
              <choose-campus
                ref="chooseCampusRef"
                :org-id="formValidate.schoolIdShow"
                @on-change="handleCampusChange"
              ></choose-campus>
            </FormItem>
          </Col>
          <Col class-name="input-select-430">
            <FormItem label="" prop="termId">
              <Select
                v-model="formValidate.termId"
                clearable
                placeholder="请选择学期"
                class="search-select-430"
                @on-open-change="handleSchoolTermSelect"
              >
                <Option
                  v-for="(item, index) in termList"
                  :key="index"
                  :value="item.termId"
                >{{ item.yearName + item.termName }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col class-name="input-select-430">
            <FormItem label="" prop="hasMonth">
              <DatePicker
                type="month"
                placeholder="请选择月份"
                format="yyyy-MM"
                class="dateMonth-430"
                transfer
                @on-change="changeMonth"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col>
            <Button type="primary" @click="handleCheckForm">选择文件</Button>
            <Button
              class="search-430"
              @click="handleDownloadExcel"
            >下载导入模板</Button>
            <span class="upload-desc">支持格式：.xlsx ，单个文件最多导入500行</span>
          </Col>
        </Row>
      </Form>
    </div>
    <!-- 学生考勤列表搜索 运营端portOrg===0、学校端 portOrg===2、机构端 portOrg===3   -->
    <div v-if="studentAttanceList" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem
            v-if="portOrg === 2"
            class="sch-form-item"
            prop="schoolIdShow"
            label=""
          >
            {{ userInfo.orgName }}
          </FormItem>
          <FormItem v-else class="sch-form-item" prop="schoolIdShow" label="">
            <RemoteSelect
              v-model="formValidate.schoolIdShow"
              placeholder="请选择学校"
              :remote-method="getSchoolList"
              :loading="loadingSchool"
              @clear="getSchoolList('')"
              @change="handleSchoolSelect"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="item in schoolList"
                :key="item.orgId"
                :label="item.name"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>

          <FormItem prop="classroomName" label="">
            <Input
              v-model="formValidate.classroomName"
              clearable
              placeholder="课程班级名称"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选择年度学期`"
              :clearable="false"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem label="">
            <Input
              v-model="selectTypeClassInput"
              placeholder="请输入订单编号/交易流水号"
              clearable
              class="search-selectInput-430"
            >
              <Select
                slot="prepend"
                v-model="selectTypeClass"
                class="search-select-430"
                placeholder="请选择订单编号/交易流水号"
              >
                <Option
                  v-for="item in selectTypeClassList"
                  :key="item.key"
                  :value="item.key"
                >{{ item.name }}</Option>
              </Select>
            </Input>
          </FormItem>
          <FormItem prop="studentName" label="">
            <Input
              v-model="formValidate.studentName"
              clearable
              placeholder="请输入学生姓名"
            ></Input>
          </FormItem>
          <FormItem prop="productName" label="">
            <Input
              v-model="formValidate.productName"
              clearable
              placeholder="请输入课程商品名称"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="classData" label="">
            <Cascader
              v-model="formValidate.classData"
              :data="gradeAndClassList"
              trigger="hover"
              placeholder="请选择行政班"
              class="mr-2"
              @on-visible-change="handleGradeSelect"
            ></Cascader>
          </FormItem>
          <FormItem prop="studentStsShow" label="">
            <Select
              v-model="formValidate.studentStsShow"
              placeholder="请选择请假状态"
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in stuStatusList"
                :key="index"
                :value="item.status"
              >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="">
            <Select
              v-model="formValidate.month"
              placeholder="请选择月份"
              clearable
              class="search-select-430"
              @on-change="onDateChange"
            >
              <Option
                v-for="(item, index) in yearMonthsList"
                :key="item"
                :value="item"
              >{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="orgId" label="">
            <span v-if="portOrg == 3">{{ userInfo.orgName }}</span>
            <choose-apply
              v-else
              ref="chooseApplyRef"
              :year-term-code="yearTermCode"
              :org-type="``"
              @on-change="handleOnApplyChange"
            ></choose-apply>
          </FormItem>
          <Button
            class="search-430"
            type="primary"
            @click="handleSearch"
          >查询</Button>
          <Button class="search-430" @click="handleFormData">重置</Button>
        </Row>
      </Form>
    </div>
    <!-- 学生考勤详情搜索  -->
    <div v-if="studentAttanceDetails" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem label="">
            <div class="date-line">
              <DatePicker
                v-model="begin"
                :options="beginDateOption"
                type="date"
                placeholder="请选择考勤时间开始时间"
                transfer
                @on-change="getThisDate($event, 'classDateStart')"
              ></DatePicker>
              <span>至</span>
              <DatePicker
                v-model="end"
                :options="endDateOption"
                type="date"
                placeholder="请选择考勤时间结束时间"
                transfer
                @on-change="getThisDate($event, 'classDateEnd')"
              ></DatePicker>
            </div>
          </FormItem>
          <FormItem prop="signStateShow" label="">
            <Select
              v-model="formValidate.signStateShow"
              placeholder="请选择考勤状态"
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in signStatusList"
                :key="index"
                :value="item.status"
              >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <Button
            class="search-430"
            type="primary"
            @click="handleSearch"
          >查询</Button>
          <Button class="search-430" @click="handleFormData">重置</Button>
        </Row>
      </Form>
    </div>
    <!-- 学生考勤行政班 和 学生考勤行政班班级 页面搜索搜索 运营端portOrg===0、学校端 portOrg===2 -->
    <div v-if="normalClassIndex || normalClassEdit" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem label="" prop="classData">
            <Cascader
              v-model="formValidate.classData"
              :data="gradeAndClassList"
              trigger="hover"
              placeholder="请选择年级班级"
              class="mr-2"
              :clearable="normalClassEdit ? false : true"
              @on-visible-change="handleGradeSelect"
            ></Cascader>
          </FormItem>
          <FormItem prop="classroomName" label="">
            <Input
              v-model="formValidate.classroomName"
              clearable
              placeholder="课程班级名称"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="studentName" label="">
            <Input
              v-model="formValidate.studentName"
              clearable
              placeholder="请输入学生姓名"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="" label="">
            <FormItem label="">
              <CascaderYearTerms
                ref="cascaderYearTerms"
                :placeholder="`请选择年度学期`"
                :clearable="false"
                :cache-year-terms="initYear"
                @on-change="onCascaderChange"
              ></CascaderYearTerms>
            </FormItem>
          </FormItem>
          <FormItem label="" prop="hasMonth">
            <DatePicker
              v-model="firstMonth"
              type="month"
              placeholder="选择考勤月份"
              style="width: 200px"
              format="yyyy-MM"
              :clearable="false"
              transfer
              @on-change="changeMonth"
            ></DatePicker>
          </FormItem>
          <FormItem label="">
            <Select
              v-model="formValidate.classType"
              clearable
              placeholder="请选择课程分类"
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in trainingTypes"
                :key="item.value"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <Button
            class="search-430"
            type="primary"
            @click="handleSearch"
          >查询</Button>
          <Button class="search-430" @click="handleFormData">重置</Button>
        </Row>
      </Form>
    </div>
    <!-- 课堂反馈 页面搜索搜索 运营端portOrg===0、学校端 portOrg===2 -->
    <div v-if="classFeedback" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem
            v-if="portOrg === 2"
            class="sch-form-item"
            prop="schoolIdShow"
            label=""
          >
            {{ userInfo.orgName }}
          </FormItem>
          <FormItem v-else class="sch-form-item" prop="schoolIdShow" label="">
            <RemoteSelect
              v-model="formValidate.schoolIdShow"
              placeholder="请选择学校"
              :remote-method="getSchoolList"
              :loading="loadingSchool"
              @clear="getSchoolList('')"
              @change="handleSchoolSelect"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="item in schoolList"
                :key="item.orgId"
                :label="item.name"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>

          <FormItem prop="orgId" label="">
            <span v-if="portOrg == 3">{{ userInfo.orgName }}</span>
            <choose-apply
              v-else
              ref="chooseApplyRef"
              org-type=""
              :year-term-code="yearTermCode"
              @on-change="handleOnApplyChange"
            ></choose-apply>
          </FormItem>
          <FormItem prop="classroomName" label="">
            <Input
              v-model="formValidate.classroomName"
              clearable
              placeholder="课程班级名称"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="teacherName" label="">
            <Input
              v-model="formValidate.teacherName"
              clearable
              placeholder="请输入任课教师"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选择年度学期`"
              :clearable="false"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem label="">
            <DatePicker
              v-model="dateValue"
              transfer
              type="daterange"
              placeholder="选择上课开始日期 至 上课结束日期"
              style="width: 280px"
              @on-change="onChangeDate($event, 'classTimeBegin')"
            ></DatePicker>
          </FormItem>

          <Button
            class="search-430"
            type="primary"
            @click="handleSearch"
          >查询</Button>
          <Button class="search-430" @click="handleFormData">重置</Button>
        </Row>
      </Form>
    </div>
    <!-- 教师请假列表页面 搜索 运营端portOrg===0、学校端 portOrg===2、机构端 portOrg===3 -->
    <div v-if="leaveListForTeacherSearch" class="class-search-box">
      <Form
        ref="searchForm"
        :model="formValidate"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem prop="leaveId" label="">
            <Input
              v-model="formValidate.leaveId"
              clearable
              placeholder="请输入请假编号ID"
              style="width: 200px"
            ></Input>
          </FormItem>
          <FormItem v-if="portOrg != 2" label="" prop="schoolId">
            <RemoteSelect
              v-model="formValidate.schoolIdShow"
              placeholder="请选择学校"
              :remote-method="getSchoolList"
              :loading="loadingSchool"
              style="width: 250px"
              @clear="getSchoolList('')"
              @change="handleSchoolSelect"
              @visible-change="loadAllList"
            >
              <el-option
                v-for="item in schoolList"
                :key="item.orgId"
                :label="item.name"
                :value="item.orgId"
              >
              </el-option>
            </RemoteSelect>
          </FormItem>
          <FormItem v-else class="sch-form-item" prop="schoolIdShow">
            {{ userInfo.orgName }}
          </FormItem>
          <FormItem label="">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              style="width: 250px"
              :placeholder="`请选择年度学期`"
              :clearable="false"
              :cache-year-terms="initYear"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </FormItem>
          <FormItem prop="classroomName" label="">
            <Input
              v-model="formValidate.classroomName"
              clearable
              placeholder="课程班级名称"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="teacherName" label="">
            <Input
              v-model="formValidate.teacherName"
              clearable
              placeholder="请输入教师姓名"
              class="search-input-430"
            ></Input>
          </FormItem>
          <FormItem prop="leaveStautsShow" label="">
            <Select
              v-model="formValidate.leaveStautsShow"
              placeholder="请选择请假审批状态"
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in leaveStatusList"
                :key="index"
                :value="item.status"
              >{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="orgId" label="">
            <span v-if="portOrg == 3">{{ userInfo.orgName }}</span>
            <choose-apply
              v-else
              ref="chooseApplyRef"
              org-type=""
              :year-term-code="yearTermCode"
              @on-change="handleOnApplyChange"
            ></choose-apply>
          </FormItem>
          <FormItem label="">
            <div class="date-line">
              <span>请假时间：</span>
              <DatePicker
                v-model="begin"
                :options="beginDateOption"
                type="date"
                transfer
                placeholder="请选择请假开始时间"
                @on-change="getThisDate($event, 'leaveTimeStart')"
              ></DatePicker>
              <span>至</span>
              <DatePicker
                v-model="end"
                :options="endDateOption"
                type="date"
                transfer
                placeholder="请选择请假结束时间"
                @on-change="getThisDate($event, 'leaveTimesEnd')"
              ></DatePicker>
            </div>
          </FormItem>
          <Button
            class="search-430"
            type="primary"
            @click="handleSearch"
          >查询</Button>
          <Button class="search-430" @click="handleFormData">重置</Button>
        </Row>
      </Form>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import operationAdmin from '@/request/operationAdmin/index.js';
import common from '@/request/common/index.js';
import courseCenter from '@/request/courseCenter/index.js';
import RemoteSelect from '@c/RemoteSelect';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms';
import ChooseApply from '@c/searchBlock/ChooseApply.vue';
import ChooseCampus from '@c/searchBlock/ChooseCampus.vue';
import { getMonthBetween, getNextMonth } from '@/utils/moment.js';

export default {
  components: {
    RemoteSelect,
    CascaderYearTerms,
    ChooseApply,
    ChooseCampus
  },
  props: {
    // 学生请假列表的搜索框
    // 学生请假页面出现在 运营端、学校端、机构端
    leaveListSearch: {
      type: Boolean,
      default: false
    },
    // 学生请假导入
    // 学生请假导入面出现在 运营端、学校端
    leadInSearch: {
      type: Boolean,
      default: false
    },
    // 学生考勤
    // 学生考勤页面出现在 运营端、学校端、机构端
    studentAttanceList: {
      type: Boolean,
      default: false
    },
    // 学生考勤明细
    studentAttanceDetails: {
      type: Boolean,
      default: false
    },
    // 学生考勤(行政班)
    // 出现在 运营端、学校端
    normalClassIndex: {
      type: Boolean,
      default: false
    },
    // 学生考勤(行政班)编辑
    // 出现在 运营端、学校端
    normalClassEdit: {
      type: Boolean,
      default: false
    },
    // 课堂反馈
    // 出现在 运营端、学校端
    classFeedback: {
      type: Boolean,
      default: false
    },
    // 教师请假
    // 出现在 运营端、学校端、教师端
    leaveListForTeacherSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 排课规则校验
    const validateMonthRule = (rule, value, callback) => {
      if (!this.formValidate.importMonthBegin && !this.formValidate.importMonthEnd) {
        return callback(new Error('请选择月份'));
      }
      callback();
    };
    return {
      initYear: [],
      modalShow: false, // 是否下载
      uploadPersent: 0, // 上传进度
      portOrg: -1,
      getGradesList: [],
      dateValue: null,
      yearMonthsList: [],
      formValidate: {
        areaCode: null,
        leaveId: null, // 请假编号
        schoolId: null, // 学校id
        schoolIdShow: -1, // 学校id 默认全部
        branchId: null, // 校区id
        termIdShow: -1, // 学期id 默认全部
        termId: null, // 学期id
        classroomName: null, // 班级名称
        classData: [], // 年级班级信息
        classId: null, // 班级id
        studentName: null, // 学生姓名
        leaveStautsShow: -1, // 请假状态展示
        leaveState: null, // 真正的请假状态
        refundStatusShow: -1, // 是否可以退款
        isRetMoney: null, // 真正是否可退款
        studentStsShow: -1, // 学生入班装填
        refundSts: null, // 退款状态
        refundStsShow: -1,
        studentSts: null,
        begin: null,
        end: null,
        productName: null, // 课程商品名称
        orgId: null, // 提供方id
        signStateShow: -1,
        signState: null, // 考勤状态 : 1未考勤 2签到 3签退 4请假
        signTimeStart: null, // 考勤开始时间
        signTimeEnd: null, // 考勤结束时间
        yearCode: null, // 学年
        termCode: null, // 学期
        payNo: null, // 交易流水号
        payOrderId: null, // 订单编号
        importMonthBegin: null, // 月份开始
        importMonthEnd: null, // 月份结束
        month: '',
        classType: null,
        selectMonth: null,
        teacherName: null,
        classTimeBegin: null,
        classTimeEnd: null,
        leaveTimeStart: null,
        leaveTimesEnd: null
      },
      begin: null,
      end: null,
      loadingSchool: false,
      schoolList: [], // 学校列表
      schoolPageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      loadingCourse: false, //
      gradeAndClassList: [], // 年级班级列表
      schoolName: '',
      num: 0,
      leaveStatusList: [
        {
          status: -1,
          name: '全部请假状态'
        },
        {
          status: 1,
          name: '已通过'
        },
        {
          status: 0,
          name: '审批中'
        },
        {
          status: 3,
          name: '已撤销'
        },
        {
          status: 2,
          name: '已驳回'
        }
      ], // 请假状态
      refundStatusList: [
        {
          status: -1,
          name: '全部是否可退款状态'
        },
        {
          status: 1,
          name: '是'
        },
        {
          status: 0,
          name: '否'
        }
      ], // 是否可退款选择列表
      refundStsList: [
        {
          status: -1,
          name: '全部退款状态'
        },
        {
          status: 2,
          name: '退款中'
        },
        {
          status: 1,
          name: '已退款'
        },
        {
          status: 0,
          name: '未退款'
        }
      ], // 退款状态选择列表

      stuStatusList: [
        {
          status: -1,
          name: '全部状态'
        },
        {
          status: 1,
          name: '已入班'
        },
        {
          status: 0,
          name: '已离班'
        }
      ], // 入班状态
      signStatusList: [
        {
          status: -1,
          name: '请选择'
        },
        {
          status: 1,
          name: '未签到'
        },
        {
          status: 2,
          name: '已签到'
        },
        {
          status: 3,
          name: '已签退'
        },
        {
          status: 4,
          name: '请假'
        },
        {
          status: 5,
          name: '缺勤'
        }
      ], // 考勤状态 : 1未考勤 2签到 3签退 4请假
      // schoolAreaList: [], // 校区列表
      termList: [], // 学期列表
      leadInRule: {
        schoolId: [
          { required: true, message: '请选择学校', trigger: 'change' }
        ],
        branchId: [
          { required: true, message: '请选择校区', trigger: 'change' }
        ],
        termId: [{ required: true, message: '请选择学期', trigger: 'change' }],
        hasMonth: [{
          required: true,
          validator: validateMonthRule, trigger: 'blur'
        }]
      },
      // applyList: [], // 提供方列表
      loadingApply: false,
      selectTypeClassInput: '', // 输入的
      selectTypeClass: '1', // 选择种类之后输入的
      selectTypeClassList: [
        {
          name: '订单编号',
          key: '1'
        },
        {
          name: '交易流水号',
          key: '2'
        }
      ],
      dataChange: 0,
      selectMonStr: '', // 选择的月份,
      areacodeList: [], // 地区列表
      loadingArea: false,
      yearTermCode: [],
      trainingTypes: [{
        value: '1',
        label: '素质课'
      }, {
        value: '2',
        label: '基础托管'
      }],
      firstMonth: null,
      listArea: [], // 机构端区域列表
      firstGetAreaCode: false,
      hasGetFirstData: false,
      searchNum: 0
    };
  },
  computed: {
    ...mapState(['userInfo']),
    // 开始日期应该不能小于结束日期
    beginDateOption() {
      const that = this;
      return {
        disabledDate(date) {
          let status = true;
          // 如果有结束日期的话
          if (that.end) {
            status =
              date && date.valueOf() < new Date(that.end).valueOf() + 86400000;
          }
          return !status;
        }
      };
    },
    // 开始日期应该不能小于结束日期
    endDateOption() {
      const that = this;
      return {
        disabledDate(date) {
          let status = true;
          // 如果有结束日期的话
          if (that.begin) {
            status =
              date &&
              date.valueOf() > new Date(that.begin).valueOf() - 86400000;
          }
          return !status;
        }
      };
    }
  },
  watch: {
    // 日期改变之后---
    selectMonStr(newVal) {
      if (!newVal) {
        this.formValidate.importMonthBegin = null;
        this.formValidate.importMonthEnd = null;
        return;
      }
      const arr = this.selectMonStr.split('-');
      const days = new Date(arr[0], arr[1], 0).getDate();
      this.formValidate.importMonthBegin = `${this.selectMonStr}-01 00:00:00`;
      this.formValidate.importMonthEnd = `${this.selectMonStr}-${days} 23:59:59`;
    }
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    if (this.$route.query.yearCode && this.$route.query.termCode) {
      this.initYear[0] = Number(this.$route.query.yearCode);
      this.initYear[1] = this.$route.query.termCode;
    }

    if (this.$route.query.leaveSts) { this.formValidate.leaveStautsShow = Number(this.$route.query.leaveSts); }

    this.searchInit();
  },

  methods: {
    searchInit(type = 'default') {
      this.searchNum = 0;
      if (this.portOrg === 3 && (this.leaveListForTeacherSearch || this.leaveListSearch || this.studentAttanceList || this.classFeedback)) {
        this.formValidate.orgId = this.userInfo.orgId;
      }
      // 学生请假-机构端，需要查询的
      if (this.leaveListSearch) {
        this.portOrg === 0 ? this.getAreaCodeList() : '';
        this.portOrg === 2 ? (this.formValidate.schoolId = this.userInfo.orgId, this.formValidate.schoolIdShow = this.userInfo.orgId) : '';
        this.portOrg === 2 && type === 'reset' ? this.handleSearch() : '';
        this.portOrg === 3 ? (this.getAreaCodeByOrg(), this.getSchoolList()) : '';
        return;
      }
      if (this.leadInSearch) {
        this.portOrg === 2 ? (this.formValidate.schoolId = this.userInfo.orgId, this.formValidate.schoolIdShow = this.userInfo.orgId, this.getTermList()) : this.getSchoolList();
        return;
      }
      if (this.studentAttanceList) {
        this.portOrg === 0 ? this.getSchoolList() : '';
        this.portOrg === 2 ? (this.formValidate.schoolId = this.userInfo.orgId, this.formValidate.schoolIdShow = this.userInfo.orgId, this.getGradeAndClass()) : '';
        this.portOrg === 2 && type === 'reset' ? this.handleSearch() : '';
        this.portOrg === 3 ? this.getSchoolList() : '';
        return;
      }
      if (this.studentAttanceDetails && type === 'reset') {
        this.handleSearch();
        return;
      }
      if (this.normalClassEdit || this.normalClassIndex) {
        this.getNowDayStr();
        type === 'reset' ? this.getSchoolId(this.formValidate.schoolId) : '';
        return;
      }
      if (this.classFeedback) {
        this.portOrg === 0 ? this.getSchoolList() : '';
        this.portOrg === 2 ? (this.formValidate.schoolId = this.userInfo.orgId, this.formValidate.schoolIdShow = this.userInfo.orgId) : '';
        type === 'reset' ? this.handleSearch() : '';
        return;
      }
      if (this.leaveListForTeacherSearch) {
        const schoolId = localStorage.getItem('schoolIdForTeacherLeave');
        if ((this.portOrg === 0 || this.portOrg === 3) && schoolId) {
          this.formValidate.schoolId = schoolId;
          this.formValidate.schoolIdShow = schoolId;
        }
        this.portOrg === 0 ? this.getSchoolList() : '';
        this.portOrg === 2 ? (this.formValidate.schoolId = this.userInfo.orgId, this.formValidate.schoolIdShow = this.userInfo.orgId) : '';
        this.portOrg === 2 && type === 'reset' ? this.handleSearch() : '';
        this.portOrg === 3 ? this.getSchoolList() : '';
        return;
      }
    },
    // 获取区域列表（用于 学生请假leaveListSearch ，运营端 portOrg===0、学校端 portOrg===2）
    async getAreaCodeList(query) {
      return new Promise(async(resolve, reject) => {
        this.loadingArea = true;
        const params = {};
        query ? params.searchStr = query : '';
        const res = await common.getListAreaCodeApi(params);
        if (res.status === 200) {
          this.areacodeList = res.message.list ? res.message.list : [];
          if (!this.formValidate.areaCode && this.areacodeList.length > 0) {
            const areaCode = localStorage.getItem('areaCodeForLeaveListSearch') ? localStorage.getItem('areaCodeForLeaveListSearch') : this.areacodeList[0].areaCode;
            const areaName = localStorage.getItem('areaNameForLeaveListSearch') ? localStorage.getItem('areaNameForLeaveListSearch') : this.areacodeList[0].areaName;
            const findResult = this.areacodeList.findIndex(item => {
              return item.areaCode === areaCode;
            });
            findResult === -1 ? this.areacodeList.unshift({
              areaCode,
              areaName
            }) : '';
            // 因为区域列表必须选定某个区域，没有全部的，所以选择一个区域之后需要储存所选择的，用于后面再次进来这个页面的默认选中
            localStorage.setItem('areaCodeForLeaveListSearch', areaCode);
            localStorage.setItem('areaNameForLeaveListSearch', areaName);
            this.formValidate.areaCode = areaCode;
          }
          this.loadingArea = false;
          // 拿到选中的区域之后，根据选定的区域，去查询该区域的学校列表
          await this.getSchoolListForAreacode();
          // 拿到选中的区域之后，如果有学期数据而且还没搜索过，就去搜索
          this.yearTermCode && this.yearTermCode.length === 2 && this.searchNum === 0 ? this.handleSearch() : '';
          resolve();
        }
      });
    },
    // 选中某个地区编码之后，查询该地区编码下的学校列表（用于 学生请假leaveListSearch ，运营端 portOrg===0）
    async getSchoolListForAreacode(query) {
      return new Promise(async(resolve, reject) => {
        this.loadingSchool = true;
        const params = {
          areaCode: this.formValidate.areaCode,
          pageNum: 1,
          pageSize: 20
        };
        query ? params.searchStr = query : '';
        const res = await operationAdmin.getListSchoolsNewByOfficeAreaCode(params);
        this.loadingSchool = false;
        if (res.status === 200) {
          this.schoolList = res.message.list ? res.message.list : [];
          this.schoolList.unshift({
            schoolId: -1,
            schoolName: '全部',
            orgId: -1,
            name: '全部学校'
          });
        }
        resolve();
      });
    },
    // 获取区域列表（用于 学生请假leaveListSearch ，机构端 portOrg===3）
    async getAreaCodeByOrg() {
      let params = {
        orgId: this.userInfo.orgId
      };
      if (this.yearTermCode.length > 0) {
        params = {
          ...params,
          yearCode: this.yearTermCode[0],
          termCode: this.yearTermCode[1]
        };
      }
      const res = await common.getListAreaByOrgIdApi(params);
      if (res.status === 200) {
        this.listArea = res.message;
        const areaCode = localStorage.getItem('areaCodeForLeaveOrg') ? localStorage.getItem('areaCodeForLeaveOrg') : '';
        const index = this.listArea.findIndex(item => {
          return areaCode === item.areaCode;
        });
        if (index === -1 && this.listArea.length > 0) {
          this.formValidate.areaCode = this.listArea[0].areaCode;
        } else if (this.listArea.length === 0) {
          this.formValidate.areaCode = '';
        } else {
          this.formValidate.areaCode = areaCode;
        }
        localStorage.setItem('areaCodeForLeaveOrg', this.formValidate.areaCode);
        // 拿到选中的区域之后，如果有学期数据而且还没搜索过，就去搜索
        this.yearTermCode && this.yearTermCode.length === 2 && this.searchNum === 0 ? this.handleSearch() : '';
      }
    },
    // 获取学校列表
    //  (用于leaveListSearch,portOrg===3;leadInSearch,portOrg===0; )
    getSchoolList(query) {
      return new Promise(async(resolve, reject) => {
        query ? (this.loadingSchool = true) : '';
        const queryTrue = query;
        if (this.portOrg === 3) {
          await this.getSchoolListOrg(queryTrue);
        } else {
          await this.getSchoolListAdmin(queryTrue);
        }
        resolve();
      });
    },
    // 请求学校列表(机构端)
    async getSchoolListOrg(query) {
      return new Promise(async(resolve, reject) => {
        const params = this.schoolPageInfo;
        query === undefined
          ? (params.searchStr = '')
          : (params.searchStr = query);
        const res = await operationAdmin.getListSchoolsNewAdmin(params);
        if (res.status === 200) {
          this.schoolList = res.message.list;
          if (res.message.list.length > 0 && this.studentAttanceList) {
            this.formValidate.schoolIdShow = res.message.list[0]['orgId'];

            this.formValidate.schoolId = res.message.list[0]['orgId'];

            this.$forceUpdate();

            this.formValidate.classData = [];
            this.formValidate.classId = null;
            this.getGradeAndClass();
            this.handleSearch(6);
          }
          if (!this.studentAttanceList) {
            this.schoolList.unshift({
              schoolId: -1,
              schoolName: '全部',
              orgId: -1,
              name: '全部学校'
            });
          }
          this.schoolPageInfo.total = Number(res.message.total);
          this.loadingSchool = false;
          if (this.leaveListForTeacherSearch && (!this.formValidate.schoolIdShow || this.formValidate.schoolIdShow === -1)) {
            const schoolId = localStorage.getItem('schoolIdForTeacherLeave') && +localStorage.getItem('schoolIdForTeacherLeave') !== -1 ? localStorage.getItem('schoolIdForTeacherLeave') : -1;
            const schoolName = localStorage.getItem('schoolNameForTeacherLeave') ? localStorage.getItem('schoolNameForTeacherLeave') : '';
            schoolId === -1 ? '' : (this.formValidate.schoolIdShow = schoolId, this.formValidate.schoolId = schoolId);
            const findResult = this.schoolList.findIndex(item => {
              return item.schoolId === schoolId;
            });
            findResult === -1 ? this.schoolList.unshift({
              orgId: schoolId,
              schoolId,
              schoolName,
              name: schoolName
            }) : '';
            this.formValidate.yearCode && this.formValidate.termCode && this.searchNum === 0 ? this.handleSearch() : '';
          }
        }
        resolve();
      });
    },
    // 请求学校列表(运营端,教育局端)
    async getSchoolListAdmin(query) {
      return new Promise(async(resolve, reject) => {
        const params = this.schoolPageInfo;
        query === undefined
          ? (params.searchStr = '')
          : (params.searchStr = query);

        const res = await operationAdmin.getListSchoolsNew(params);
        if (res.status === 200) {
          this.schoolList = res.message.list.map(item => {
            item.schoolId = item.orgId;
            item.schoolName = item.name;
            return item;
          });
          if (!this.studentAttanceList) {
            this.schoolList.unshift({
              schoolId: -1,
              schoolName: '全部',
              orgId: -1,
              name: '全部学校'
            });
          }
          this.schoolPageInfo.total = Number(res.message.total);
          this.loadingSchool = false;
          if (this.studentAttanceList && (!this.formValidate.schoolIdShow || this.formValidate.schoolIdShow === -1)) {
            const schoolId = localStorage.getItem('schoolIdForStudentAttendance') && +localStorage.getItem('schoolIdForStudentAttendance') !== -1 ? localStorage.getItem('schoolIdForStudentAttendance') : this.schoolList[0].schoolId;
            const schoolName = localStorage.getItem('schoolNameForStudentAttendance') ? localStorage.getItem('schoolNameForStudentAttendance') : this.schoolList[0].schoolName;
            this.formValidate.schoolIdShow = schoolId;
            this.formValidate.schoolId = schoolId;
            const findResult = this.schoolList.findIndex(item => {
              return item.schoolId === schoolId;
            });
            findResult === -1 ? this.schoolList.unshift({
              orgId: schoolId,
              schoolId,
              schoolName,
              name: schoolName
            }) : '';
            localStorage.setItem('schoolIdForStudentAttendance', schoolId);
            localStorage.setItem('schoolNameForStudentAttendance', schoolName);
            this.getGradeAndClass();
            this.formValidate.yearCode && this.formValidate.termCode && this.searchNum === 0 ? this.handleSearch(101) : '';
          }
          if (this.leaveListForTeacherSearch && !query) {
            const schoolId = localStorage.getItem('schoolIdForTeacherLeave') && +localStorage.getItem('schoolIdForTeacherLeave') !== -1 ? localStorage.getItem('schoolIdForTeacherLeave') : -1;
            const schoolName = localStorage.getItem('schoolNameForTeacherLeave') ? localStorage.getItem('schoolNameForTeacherLeave') : '';
            schoolId === -1 ? '' : (this.formValidate.schoolIdShow = schoolId, this.formValidate.schoolId = schoolId);
            const findResult = this.schoolList.findIndex(item => {
              return item.schoolId === schoolId;
            });
            findResult === -1 ? this.schoolList.unshift({
              orgId: schoolId,
              schoolId,
              schoolName,
              name: schoolName
            }) : '';
            this.formValidate.yearCode && this.formValidate.termCode && this.searchNum === 0 ? this.handleSearch() : '';
          }
        }
        resolve();
      });
    },
    // 当选择了某个学校之后
    // 用于 leaveListSearch portOrg===0,portOrg===3;leadInSearch portOrg===0;
    handleSchoolSelect(option) {
      if (!option) {
        return;
      }
      this.formValidate.schoolIdShow = option;
      this.formValidate.schoolId = option;
      this.$forceUpdate();
      if (this.studentAttanceList) {
        this.formValidate.classData = [];
        this.formValidate.classId = null;
        this.getGradeAndClass();
      }
      if (this.leadInSearch) {
        this.getTermList();
      }
      if (this.portOrg !== 3 && (this.studentAttanceList || this.classFeedback)) {
        this.$refs.chooseApplyRef && this.$refs.chooseApplyRef.handleClear();
      }
    },
    handleClearSchool() {
      this.formValidate.schoolIdShow = null;
      this.formValidate.schoolId = null;
      this.gradeAndClassList = [];
      this.formValidate.classData = [];
      this.formValidate.classId = null;
    },
    // 请求年级班级列表
    async getGradeAndClass() {
      return new Promise(async(resolve, reject) => {
        const params = {
          schoolId: this.formValidate.schoolIdShow
        };
        const res = await common.getListOrgGradeClass(params);
        if (res.status === 200) {
          this.gradeAndClassList = res.message;
        }
        resolve();
      });
    },
    // 请求学期列表 termId的形式
    // 用于 leadInSearch 的搜索使用 portOrg===0、portOrg===2
    async getTermList() {
      const params = {
        schoolId: this.formValidate.schoolIdShow
      };
      const res = await courseCenter.getyearTermsList(params);
      if (res.status === 200) {
        this.termList = res.message;
        if (this.termList.length) {
          this.formValidate.termId = this.termList[0].termId;
          this.formValidate.yearName =
            this.termList[0].yearName + this.termList[0].termName;
        }
      }
    },
    // 拿到选中的学期数据 termCode、yearCode的形式
    // 用于 学生请假leaveListSearch 运营端 portOrg===0、学校端 portOrg===2、机构端 portOrg===3
    onCascaderChange(v) {
      this.yearTermCode = v;
      this.formValidate.yearCode = v[0];
      this.formValidate.termCode = v[1];
      this.dataChange++;
      // 学生请假，如果没有搜索过
      if (this.leaveListSearch && this.searchNum === 0) {
        this.portOrg === 0 && this.formValidate.areaCode ? this.handleSearch() : '';
        this.portOrg === 2 ? this.handleSearch() : '';
        this.portOrg === 3 && this.formValidate.areaCode ? this.handleSearch() : '';
        return;
      }

      if ((this.normalClassIndex || this.normalClassEdit) && this.portOrg !== 2) {
        // 学期切换，要相应地切换学校
        this.$eventHub.$emit('changeYearTermCode', this.yearTermCode);
      }
      if (this.normalClassIndex) {
        this.formValidate.schoolIdShow && this.searchNum === 0 ? this.handleSearch() : '';
        return;
      }
      if (this.normalClassEdit) {
        this.formValidate.schoolIdShow && this.searchNum === 0 && this.formValidate.classData.length > 0 ? this.handleSearch() : '';
        return;
      }
      if (this.classFeedback) {
        this.searchNum === 0 ? this.handleSearch() : '';
        return;
      }
      if (this.leaveListForTeacherSearch) {
        this.searchNum === 0 ? this.handleSearch() : '';
        return;
      }
      setTimeout(() => {
        const sysYt = this.$refs.cascaderYearTerms.getObjResult();
        const sysYTBeginTime = sysYt ? sysYt.beginTime : '';
        const sysYTEndTime = sysYt ? sysYt.endTime : '';
        if (sysYTBeginTime && sysYTEndTime) {
          this.yearMonthsList = getMonthBetween(sysYTBeginTime, sysYTEndTime);
          this.formValidate.month = '';
        }
        console.log(this.yearMonthsList);
        // 学生考勤，如果没有搜索过
        if (this.studentAttanceList && this.searchNum === 0) {
          console.log('来到了学生考勤搜索----342');
          this.formValidate.schoolIdShow && this.formValidate.schoolIdShow !== -1 ? this.handleSearch(102) : '';
          return;
        }
        if (this.leaveListSearch && this.portOrg === 2) {
          this.handleSearch(12);
        }
      }, 400);
    },
    // 一进来获取当前日期
    getNowDayStr() {
      const selectMonDate = new Date();
      const year = selectMonDate.getFullYear();
      const month = selectMonDate.getMonth() + 1;
      const selectMonStr = `${year}-${month > 9 ? month : '0' + month}`;
      this.firstMonth = selectMonDate;
      this.formValidate.selectMonth = selectMonStr;
    },
    // 用于 normalClassIndex 和 normalClassEdit 页面的搜索，
    // 因为这两个页面是切换学校就要发起搜索，学校切换不在这个组件进行
    async getSchoolId(id) {
      this.formValidate.schoolIdShow = id;
      this.formValidate.schoolId = id;
      // console.log('传送学校id');
      if (this.normalClassIndex || this.normalClassEdit) {
        this.formValidate.classData = [];
        this.formValidate.classId = null;
        await this.getGradeAndClass();
        if (this.gradeAndClassList.length > 0 && this.normalClassEdit) {
          this.formValidate.classData = [this.gradeAndClassList[0].value, this.gradeAndClassList[0].children[0].value];
        }
      }
      if (this.yearTermCode.length !== 0) {
        this.handleSearch();
      }
    },
    // 获取新的月份
    changeMonth(formatDate, type) {
      console.log(formatDate, '选择月份');
      this.selectMonStr = formatDate;
      this.formValidate.selectMonth = formatDate;
    },

    handleSelectArea(value) {
      console.log(value, '拿到的---342');
      localStorage.setItem('areaCodeForLeaveOrg', value);
    },
    handleAreaSelect(option) {
      if (!option) {
        return;
      }
      this.formValidate.areaCode = option;
      localStorage.setItem('areaCodeForLeaveListSearch', this.formValidate.areaCode);
      const findResult = this.areacodeList.findIndex(item => {
        return item.areaCode === this.formValidate.areaCode;
      });
      findResult > -1 ? localStorage.setItem('areaNameForLeaveListSearch', this.areacodeList[findResult].areaName) : '';
      this.formValidate.schoolId = null;// 学校id
      this.formValidate.schoolIdShow = -1; // 学校id 默认全部
      this.formValidate.classData = [];
      this.formValidate.classId = null;
      this.$forceUpdate();
      this.getSchoolListForAreacode();
    },
    loadAllAreaList(val) {
      if (!val) {
        this.getAreaCodeList('');
      }
    },
    // 学期改变
    onchangeTerm(res) {
      this.formValidate.termId = res.termId;
      this.handleSearch(3);
    },

    onDateChange(month) {
      console.log(month);
      // this.formValidate.classDate = month ? `${month}-01 00:00:00` : null
    },
    // 获取当前月份的开始时间到结束时间
    getNowMonth() {
      const selectMonDate = new Date();
      const year = selectMonDate.getFullYear();
      const month = selectMonDate.getMonth() + 1;
      const selectMonStr = `${year}-${month > 9 ? month : '0' + month}`;
      const arr = selectMonStr.split('-');
      const days = new Date(arr[0], arr[1], 0).getDate();
      this.formValidate.begin = this.begin = `${selectMonStr}-01 00:00:00`;
      this.formValidate.end = this.end = `${selectMonStr}-${days} 23:59:59`;
      //   this.beginEndDate = [`${selectMonStr}-01 00:00:00`, `${selectMonStr}-${days} 23:59:59`];
    },
    /** ***** 有关学校列表的操作 start  ********/
    loadAllList(val) {
      if (!val) {
        this.leaveListSearch && this.portOrg === 0 ? this.getSchoolListForAreacode('') : this.getSchoolList('');
      }
    },

    /** ***** 有关学校列表的操作 end  ********/
    /** ***** 有关学期的操作 start  ********/
    // 学校校区下拉框展开或收起时触发(没有选择学校的时候要弹出提示)
    handleSchoolTermSelect(status) {
      if (status && this.formValidate.schoolIdShow === '') {
        return this.$Message.error('请先选择学校！');
      }
    },
    // 校区选择branchId
    handleCampusChange(val) {
      this.formValidate.branchId = val;
    },
    // 年级列表
    async getGradesFunc() {
      const params = {
        schoolId: this.formValidate.schoolIdShow
      };
      const res = await this.$http.getGrades(params);
      if (res.status == 200) {
        this.getGradesList = res.message;
      }
    },
    /** ***** 有关学期的操作 end  ********/
    /** ***** 有关请求提供方的操作 start  ********/
    // loadAllApplyList(val) {
    //   if (!val) {
    //     this.getApplyList('');
    //   }
    // },
    // 提供方组件值改变
    handleOnApplyChange(val) {
      this.formValidate.orgId = val.orgId === '' ? null : val.orgId;
      // if (this.leaveListForTeacherSearch) {
      //   this.formValidate.orgId = val.orgId === '' ? null : val.orgId;
      // } else {
      //   this.formValidate.orgId = val.orgId;
      // }
    },
    /** ***** 有关请求提供方的操作 end  ********/
    /** ***** 有关年级班级的操作 start  ********/
    // 选择年级之前，先看有没有选学校
    handleGradeSelect(status) {
      if (
        (status && this.formValidate.schoolIdShow === '') ||
        this.formValidate.schoolIdShow === -1
      ) {
        return this.$Message.error('请先选择学校！');
      }
    },

    /** ***** 有关年级班级的操作 end  ********/
    getThisDate(date, name) {
      console.log(date, name, '=====');
      if (date) {
        this.formValidate[name] =
          name === 'begin' || name === 'classDateStart' || name === 'leaveTimeStart'
            ? `${date} 00:00:00`
            : `${date} 23:59:59`;
      } else {
        this.formValidate[name] = null;
      }
    },
    // 日期区间
    onChangeDate(date, type) {
      console.log(date, '拿到的----32');
      if (type === 'classTimeBegin') {
        this.formValidate['classTimeBegin'] = date[0] ? `${date[0]} 00:00:00` : null;
        this.formValidate['classTimeEnd'] = date[1] ? `${date[1]} 23:59:59` : null;
      } else {
        this.formValidate['begin'] = date[0] ? date[0] : null;
        this.formValidate['end'] = date[1] ? date[1] : null;
      }
    },
    // 校验导入请假单的搜索数据表单
    async checkLeadInFormVal() {
      return new Promise(async(resolve, reject) => {
        this.$refs.searchForm.validate(valid => {
          if (valid) {
            const obj = {
              schoolId: this.formValidate.schoolIdShow,
              termId: this.formValidate.termId,
              branchId: this.formValidate.branchId,
              importMonthBegin: this.formValidate.importMonthBegin,
              importMonthEnd: this.formValidate.importMonthEnd
            };
            resolve(obj);
          } else {
            reject();
          }
        });
      });
    },
    async handleCheckForm() {
      const obj = await this.checkLeadInFormVal();
      this.$emit('getSearchValue', obj);
    },
    handleDownloadExcel() {
      this.$emit('downExcel');
    },
    // 点击查询按钮
    handleSearch(type) {
      console.log('来查询---', type);
      this.searchNum++;
      this.formValidate.leaveState =
        this.formValidate.leaveStautsShow === -1
          ? null
          : this.formValidate.leaveStautsShow;
      this.formValidate.isRetMoney =
        this.formValidate.refundStatusShow === -1
          ? null
          : this.formValidate.refundStatusShow;
      this.formValidate.refundSts =
        this.formValidate.refundStsShow === -1
          ? null
          : this.formValidate.refundStsShow;
      this.formValidate.studentSts =
        this.formValidate.studentStsShow === -1
          ? null
          : this.formValidate.studentStsShow;
      this.formValidate.classId =
        this.formValidate.classData.length === 2
          ? this.formValidate.classData[1]
          : null;
      this.formValidate.signState =
        this.formValidate.signStateShow === -1
          ? null
          : this.formValidate.signStateShow;
      this.formValidate.classroomName = this.formValidate.classroomName && this.formValidate.classroomName.replace(/\s+/g, '') === '' ? null : this.formValidate.classroomName;
      this.formValidate.teacherName = this.formValidate.teacherName && this.formValidate.teacherName.replace(/\s+/g, '') === '' ? null : this.formValidate.teacherName;
      if (this.selectTypeClass === '1') {
        this.formValidate.payOrderId = this.selectTypeClassInput
          ? this.selectTypeClassInput
          : null;
        this.formValidate.payNo = null;
      } else if (this.selectTypeClass === '2') {
        this.formValidate.payOrderId = null;
        this.formValidate.payNo = this.selectTypeClassInput
          ? this.selectTypeClassInput
          : null;
      }
      const searchParams = {};

      // 去除不必要的请求参数---
      Object.keys(this.formValidate)
        .filter(item => item.indexOf('Show') === -1 && item !== 'classData')
        .forEach(item => {
          searchParams[item] = this.formValidate[item];
        });
      const month = searchParams.month; let classDateStart = null; let classDateEnd = null;
      delete searchParams.month;
      if (month) {
        classDateStart = `${month}-01 00:00:00`;
        classDateEnd = `${getNextMonth(`${month}-01`)} 00:00:00`;
        searchParams.classDateStart = classDateStart;
        searchParams.classDateEnd = classDateEnd;
      }
      if (this.studentAttanceList && this.portOrg !== 2) {
        localStorage.setItem('schoolIdForStudentAttendance', this.formValidate.schoolId);
        const findResult = this.schoolList.findIndex(item => {
          return item.schoolId === this.formValidate.schoolId;
        });
        findResult > -1 ? localStorage.setItem('schoolNameForStudentAttendance', this.schoolList[findResult].name) : '';
      }
      if (this.leaveListForTeacherSearch && this.portOrg !== 2) {
        console.log('拿到的数据', this.formValidate.schoolId);
        localStorage.setItem('schoolIdForTeacherLeave', this.formValidate.schoolId === null ? '' : this.formValidate.schoolId);
        const findResult = this.schoolList.findIndex(item => {
          return item.schoolId === this.formValidate.schoolId;
        });
        console.log(findResult > -1 ? this.schoolList[findResult].name : findResult, '拿到的数据学校名字');
        findResult > -1 ? localStorage.setItem('schoolNameForTeacherLeave', this.schoolList[findResult].name) : '';
      }
      this.$emit('getSearchValue', searchParams);
    },
    // 重置表单数据
    handleFormData() {
      // 置空表单项
      this.$refs['searchForm'].resetFields();
      // 没有绑定表单的项，先直接置空
      this.dateValue = null;
      this.formValidate.begin = null;
      this.formValidate.end = null;
      this.formValidate.classTimeBegin = null;
      this.formValidate.classTimeEnd = null;
      this.formValidate.classDateStart = null;
      this.formValidate.classDateEnd = null;
      this.formValidate.leaveTimeStart = null;
      this.formValidate.leaveTimesEnd = null;
      this.begin = null;
      this.end = null;
      this.formValidate.leaveStautsShow = -1;
      this.formValidate.classroomName = null;
      this.formValidate.month = '';
      if (this.portOrg !== 2 && !this.studentAttanceList && !this.normalClassIndex && !this.normalClassEdit) {
        this.formValidate.schoolId = null;
      }
      const yearTerms = this.$refs.cascaderYearTerms && this.$refs.cascaderYearTerms.handleDefault();
      console.log(yearTerms, '拿到的----重置学期----');
      if (yearTerms && yearTerms.length) {
        this.formValidate.yearCode = yearTerms[0];
        this.formValidate.termCode = yearTerms[1];
      }

      this.$refs.chooseApplyRef && this.$refs.chooseApplyRef.handleClear();
      this.selectTypeClassInput = '';

      if (this.leaveListForTeacherSearch && +this.portOrg !== 2) {
        this.formValidate.schoolId = null;
        this.formValidate.schoolIdShow = -1;
        localStorage.setItem('schoolIdForTeacherLeave', '');
        localStorage.setItem('schoolNameForTeacherLeave', '');
      }
      this.searchInit('reset');
    }

  }
};
</script>
<style lang="scss" scoped>
.btn-box {
  // display: flex;
  // vertical-align: center;
  button + button {
    margin-left: 16px;
  }
  .btn {
    margin-left: 16px;
    font-size: 16px;
  }
}
.page-box {
  padding: 0 16px;
}
.slot-box {
  margin-bottom: 16px;
}
.date-line {
  display: flex;
  align-items: center;
  span {
    margin: 0 8px;
  }
}
.cancel-box {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
.upload-desc {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #888888;
  line-height: 20px;
  margin-left: 16px;
}
</style>
